<template>
    <div class="simple-upload-container">
        <div class="total-progress">
            <div class="btns">
                <el-button-group>
                    <el-button :disabled="changeDisabled" typle="primary" @click="chooseFiles" class="choose-file-btn" size="small">
                        <i class="el-icon-upload2 el-icon--left" size="mini" ></i>选择文件
                        <input
                                v-if="!changeDisabled"
                                type="file"
                                ref="files"
                                style="display: none;"
                                multiple
                                class="select-file-input"
                                onclick=""
                                @change="handleFileChange"
                        />
                    </el-button>
                </el-button-group>
                <!--<slot name="header"></slot>-->
            </div>
        </div>
        <div class="file-list">
            <!--<el-collapse v-if="uploadFiles.length" accordion>-->
            <!--<el-collapse-item v-for="(item, index) in uploadFiles" :key="index">-->
            <template v-for="(item, index) in uploadFiles">
                <div class="progress-box">
                    <div class="list-item">
                        <div style="width:100%; display: flex;flex-direction: row; font-size: 14px; color: #333;">
                            <div class="item-name">
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="item-size">{{ item.size | transformByte }}</div>
                        </div>
                        <div style="width:100%; display: flex;flex-direction: row;margin-top: 10px;">
                            <div v-if="item.hashProgress !== 100 && index === fileIndex" class="item-progress">
                                <span>{{ status === 'wait' ? '准备读取文件' : '正在读取文件' }}</span>
                                <el-progress :percentage="item.hashProgress" v-if="item.hashProgress"/>
                            </div>
                            <div v-else-if="item.hashProgress !== 100 && index !== fileIndex" class="item-wait">
                                <span>等待处理中</span>
                            </div>
                            <div v-else class="item-progress">
                                <span>文件上传进度：</span>
                                <el-progress :percentage="item.uploadProgress" v-if="item.uploadProgress"/>
                            </div>
                        </div>
                        <div style="width:100%; height: 1px;background-color: #ddd;"></div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    // import {saveObjArr, getObjArr, clearLocalStorage} from '@/localstorage';
    import axios from 'axios';

    var instance = axios.create({headers: {'Content-Type': 'multipart/form-data'},});
    var chunkSize = 10 * 1024 * 1024; // 切片大小
    // 所有文件状态
    const Status = {
        wait: 'wait',
        pause: 'pause',
        uploading: 'uploading',
        hash: 'hash',
        error: 'error',
        done: 'done'
    };

    // 单个文件的状态
    const fileStatus = {
        wait: 'wait',
        uploading: 'uploading',
        success: 'success',
        error: 'error',
        secondPass: 'secondPass',
        pause: 'pause',
        resume: 'resume'
    };
    // 单个文件的状态 对应描述
    const fileStatusStr = {
        wait: '待上传',
        uploading: '上传中',
        success: '成功',
        error: '失败',
        secondPass: '已秒传',
        pause: '暂停',
        resume: '恢复'
    };

    export default {
        name: 'ChunkUpload',
        filters: {
            transformByte(size) {
                if (!size) {
                    return '0B';
                }

                var num = 1024.0; // byte

                if (size < num) {
                    return size + 'B';
                }
                if (size < Math.pow(num, 2)) {
                    return (size / num).toFixed(2) + 'K';
                } // kb
                if (size < Math.pow(num, 3)) {
                    return (size / Math.pow(num, 2)).toFixed(2) + 'M';
                } // M
                if (size < Math.pow(num, 4)) {
                    return (size / Math.pow(num, 3)).toFixed(2) + 'G';
                } // G
                return (size / Math.pow(num, 4)).toFixed(2) + 'T'; // T
            },
            // 单个文件状态格式化
            fileStatus(status) {
                return fileStatusStr[fileStatus[status]];
            }
        },
        props: {
            headers: {
                type: Object,
                default: null
            },
            // 切片大小
            chunkSize: {
                type: Number,
                default: 10 * 1024 * 1024
            },
            // 上传并发数
            threads: {
                type: Number,
                default: 1
            },
            // 错误重试次数
            chunkRetry: {
                type: Number,
                default: 3
            }
        },
        data: () => ({
            fileIndex: 0, // 当前正在被遍历的文件下标
            uploadFiles: [],
            worker: null,
            cancels: [], // 存储要取消的请求
            tempThreads: 1,
            // 默认状态
            status: Status.wait
        }),
        computed: {
            changeDisabled() {
                return ![Status.wait, Status.done].includes(this.status);
            },
            uploadDisabled() {
                return !this.uploadFiles.length || [Status.pause, Status.done, Status.uploading, Status.hash].includes(this.status);
            },
            pauseDisabled() {
                return [Status.hash, Status.wait, Status.done, Status.pause].includes(this.status);
            },
            resumeDisabled() {
                return ![Status.pause].includes(this.status);
            },
            clearDisabled() {
                return !this.uploadFiles.length;
            },
            fileStatuIcon(status) {
                return function (status) {
                    var className = '';
                    switch (status) {
                        case 'uploading':
                            className = 'el-icon-loading';
                            break;
                        case 'success':
                        case 'secondPass':
                            className = 'el-icon-circle-check';
                            break;
                        case 'error':
                            className = 'el-icon-circle-close';
                            break;
                    }
                    return className + ' el-icon--left';
                };
            }
        },
        destroyed() {
            this.clearFiles();
        },
        created() {
            this.setAxios();
            this.tempThreads = this.threads;
            // this.$on('submit', function() {
            //     console.log("recv start-upload")
            //     this.handleUpload()
            // })
        },
        methods: {
            chooseFiles() {
                // console.log("chooseFIles")
                this.$refs.files.click()
            },
            handleFileChange(e) {
                const files = e.target.files;
                console.log('handleFileChange -> file ', files);
                if (!files) return;

                this.$emit('file_list', files)
                this.fileIndex = 0; // 重置文件下标
                // console.log('handleFileChange -> this.uploadFiles', this.uploadFiles);
                // 判断文件选择的个数
                if (this.limit && files.length > this.limit) {
                    this.onExceed && this.onExceed(files);
                    return;
                }

                this.status = Status.wait;

                const postFiles = Array.prototype.slice.call(files);
                // console.log('handleFileChange -> postFiles', JSON.stringify(postFiles));
                postFiles.forEach((item) => {
                    this.handleStart(item);
                });
                // this.handleUpload()
            },
            handleStart(rawFile) {
                // 初始化部分自定义属性
                rawFile.status = fileStatus.wait;
                rawFile.chunkList = [];
                rawFile.uploadProgress = 0;
                rawFile.fakeUploadProgress = 0; // 假进度条，处理恢复上传后，进度条后移的问题
                rawFile.hashProgress = 0;
                this.uploadFiles.push(rawFile);
            },
            async handleUpload() {
                // console.log('handleUpload -> this.uploadFiles', JSON.stringify(this.uploadFiles));
                if (!this.uploadFiles) return;
                this.status = Status.uploading;
                const filesArr = this.uploadFiles;

                for (let i = 0; i < filesArr.length; i++) {
                    this.fileIndex = i;
                    if (['secondPass', 'success', 'error'].includes(filesArr[i].status)) {
                        console.log('跳过已上传成功或已秒传的或失败的');
                        continue;
                    }

                    const fileChunkList = this.createFileChunk(filesArr[i]);

                    // 若不是恢复，再进行hash计算
                    if (filesArr[i].status !== 'resume') {
                        this.status = Status.hash;
                        // hash校验，是否为秒传
                        filesArr[i].hash = await this.calculateHash(fileChunkList);

                        // 若清空或者状态为等待，则跳出循环
                        if (this.status === Status.wait) {
                            console.log('若清空或者状态为等待，则跳出循环');
                            break;
                        }

                        console.log('handleUpload -> hash ', filesArr[i].hash);
                    }

                    this.status = Status.uploading;
                    const verifyRes = await this.verifyUpload(filesArr[i].name, filesArr[i].hash);
                    if (verifyRes.totalChunks && verifyRes.chunkNumber == verifyRes.totalChunks) {
                        filesArr[i].status = fileStatus.secondPass;
                        filesArr[i].uploadProgress = 100;
                        // const uploadOneFile = {
                        //     fileName: filesArr[i].name,
                        //     fileHash: filesArr[i].hash
                        // }
                        // this.isAllStatus(uploadOneFile);
                        await this.mergeRequest(filesArr[i]);
                    } else {
                        let hasUploadedChunk = verifyRes.chunkNumber
                        console.log('开始上传文件----》', filesArr[i].name);
                        console.log("hasUploadedChunk is " + hasUploadedChunk)
                        filesArr[i].status = fileStatus.uploading;
                        // const getChunkStorage = this.getChunkStorage(filesArr[i].hash);
                        filesArr[i].fileHash = filesArr[i].hash; // 文件的hash，合并时使用
                        filesArr[i].hasUploaded = hasUploadedChunk
                        let totalChunks = fileChunkList.length
                        filesArr[i].chunkList = fileChunkList.map(({file}, index) => ({
                            fileHash: filesArr[i].hash,
                            fileName: filesArr[i].name,
                            index,
                            totalChunks: totalChunks,
                            hash: filesArr[i].hash + '-' + index,
                            chunk: file,
                            size: file.size,
                            // uploaded: getChunkStorage && getChunkStorage.includes(index), // 标识：是否已完成上传
                            // progress: getChunkStorage && getChunkStorage.includes(index) ? 100 : 0,
                            // status: getChunkStorage && getChunkStorage.includes(index) ? 'success' : 'wait' // 上传状态，用作进度状态显示
                        }));

                        this.$set(filesArr, i, filesArr[i]);

                        // console.log('handleUpload ->  this.chunkData ', JSON.stringify(filesArr[i]))
                        await this.uploadChunks(filesArr[i]);
                    }
                }
            },
            // 将切片传输给服务端
            async uploadChunks(data) {
                // console.log('uploadChunks -> data', data);
                var chunkData = data.chunkList;
                const hasUploadedChunk = data.hasUploaded
                // console.log("uploadChunks chunkData length " + chunkData.length)
                return new Promise(async (resolve, reject) => {
                    const requestDataList = chunkData.filter(item=>{
                        return item.index >= hasUploadedChunk
                    })
                        .map(({fileHash, totalChunks, chunk, fileName, index}) => {
                            // console.log("index is " + index)
                            const formData = new FormData();
                            formData.append('uuid', fileHash);
                            formData.append("totalChunks", totalChunks);
                            formData.append('file', chunk);
                            formData.append('chunkNumber', index + 1); // 文件名使用切片的下标
                            // console.log("111111111111111111 formData is " + JSON.stringify(formData))
                            // for (var [a, b] of formData.entries()) {
                            //     console.log("11111111111   ", a, b);
                            // }
                            return {formData, index, fileName};
                        });

                    // console.log('uploadChunks -> requestDataList ', JSON.stringify(requestDataList.formData))
                    // console.log('uploadChunks -> requestDataList length ', requestDataList.length)

                    try {
                        await this.sendRequest(requestDataList, chunkData, hasUploadedChunk);
                        // console.log('uploadChunks -> chunkData', chunkData);
                        // console.log('ret', ret);
                    } catch (error) {
                        // 上传有被reject的
                        this.$message.error('亲 上传失败了,考虑重试下呦' + error);
                        return;
                    }

                    // 合并切片
                    const isUpload = chunkData.some((item) => item.uploaded === false);
                    // console.log('created -> isUpload', isUpload);
                    if (isUpload) {
                        alert('存在失败的切片');
                    } else {
                        // 执行合并
                        try {
                            await this.mergeRequest(data);
                            resolve();
                        } catch (error) {
                            reject();
                        }
                    }
                });
            },
            // 并发处理
            sendRequest(forms, chunkData, hasUploaded) {
                // console.log('sendRequest -> forms ', JSON.stringify(forms));
                // console.log('sendRequest -> chunkData ', chunkData);
                var finished = 0;
                const total = forms.length;
                // console.log("total is " + total)
                const that = this;
                const retryArr = []; // 数组存储每个文件hash请求的重试次数，做累加 比如[1,0,2],就是第0个文件切片报错1次，第2个报错2次

                return new Promise((resolve, reject) => {
                    const handler = () => {
                        // console.log('handler -> forms', forms);
                        if (forms.length) {
                            // 出栈
                            const formInfo = forms.shift();
                            const formData = formInfo.formData;
                            const index = formInfo.index;
                            // console.log("chunkUpload for " + index)
                            instance
                                .post('/chunkUpload/upload/', formData, {
                                    onUploadProgress: that.createProgresshandler(chunkData[index], hasUploaded)
                                })
                                .then((res) => {
                                    // console.log('chunkUpload -> res', JSON.stringify(res));
                                    // 更改状态
                                    chunkData[index].uploaded = true;
                                    chunkData[index].status = 'success';

                                    // 存储已上传的切片下标
                                    // this.addChunkStorage(chunkData[index].fileHash, index);

                                    finished++;
                                    handler();
                                })
                                .catch((e) => {
                                    // 若状态为暂停或等待，则禁止重试
                                    // console.log('handler -> this.status', this.status);
                                    if ([Status.pause, Status.wait].includes(this.status)) return;

                                    console.warn('出现错误', e);
                                    // console.log('handler -> retryArr', retryArr);
                                    if (typeof retryArr[index] !== 'number') {
                                        retryArr[index] = 0;
                                    }

                                    // 更新状态
                                    chunkData[index].status = 'warning';

                                    // 累加错误次数
                                    retryArr[index]++;

                                    // 重试3次
                                    if (retryArr[index] >= this.chunkRetry) {
                                        console.warn(' 重试失败--- > handler -> retryArr', retryArr, chunkData[index].hash);
                                        return reject('重试失败', retryArr);
                                    }

                                    console.log('handler -> retryArr[finished]', `${chunkData[index].hash}--进行第 ${retryArr[index]} '次重试'`);
                                    console.log(retryArr);

                                    this.tempThreads++; // 释放当前占用的通道

                                    // 将失败的重新加入队列
                                    forms.push(formInfo);
                                    handler();
                                });
                        }

                        if (finished >= total) {
                            resolve('done');
                        }
                    };

                    // 控制并发
                    for (let i = 0; i < this.tempThreads; i++) {
                        handler();
                    }
                });
            },
            // 通知服务端合并切片
            mergeRequest(data) {
                let that = this
                return new Promise((resolve, reject) => {
                    that.$post(that.$uri.chunkUpload.merge, {
                        uuid: data.fileHash,
                        fileName: data.name,
                        totalChunks: data.chunkList.length
                    }).then(res => {
                        // 清除storage
                        console.log("mergeChunk res " + JSON.stringify(res))
                        if (res.success == true) {
                            data.status = fileStatus.success;
                            const uploadOneFile = {
                                fileName: data.name,
                                fileHash: data.fileHash
                            }
                            // 判断是否所有都成功上传
                            this.isAllStatus(uploadOneFile);
                            resolve();
                        } else {
                            // 文件块数量不对，清除缓存
                            // clearLocalStorage(data.fileHash);
                            data.status = fileStatus.error;
                            this.status = Status.wait;
                            resolve();
                        }
                    }).catch((err) => {
                        console.log('mergeRequest -> err', err);
                        data.status = fileStatus.error;
                        this.$emit('upload_fail', err)
                        reject();
                    })
                });
            },
            // 创建文件切片
            createFileChunk(file, size = chunkSize) {
                const fileChunkList = [];
                var count = 0;
                while (count < file.size) {
                    fileChunkList.push({
                        file: file.slice(count, count + size)
                    });
                    count += size;
                }
                // console.log('createFileChunk -> fileChunkList', fileChunkList);
                return fileChunkList;
            },

            // 暂停上传
            handlePause() {
                this.status = Status.pause;
                if (this.uploadFiles.length) {
                    const currentFile = this.uploadFiles[this.fileIndex];
                    currentFile.status = fileStatus.pause;
                    // 将当前进度赋值给假进度条
                    currentFile.fakeUploadProgress = currentFile.uploadProgress;
                    // console.log('handlePause -> currentFile', currentFile);
                }
                while (this.cancels.length > 0) {
                    this.cancels.pop()('取消请求');
                }
            },
            // 恢复上传
            // handleResume() {
            //     this.status = Status.uploading;
            //     // console.log('handleResume -> this.uploadFiles[fileIndex]', this.uploadFiles[this.fileIndex]);
            //     this.uploadFiles[this.fileIndex].status = fileStatus.resume;
            //     this.handleUpload();
            // },
            // 文件上传之前的校验： 校验文件是否已存在
            verifyUpload(fileName, fileHash) {
                let that = this
                return new Promise((resolve) => {
                    that.$post(that.$uri.chunkUpload.checkStatus, {uuid: fileHash}).then(res => {
                        console.log('verifyUpload -> res', JSON.stringify(res))
                        if (res.success) {
                            resolve(res.data);
                        }
                    }).catch((err) => {
                        console.log('verifyUpload -> err', err);
                    });
                });
            },
            // 生成文件 hash（web-worker）
            calculateHash(fileChunkList) {
                // console.log('calculateHash -> fileChunkList ', fileChunkList);
                return new Promise((resolve) => {
                    this.worker = new Worker('./hash.js');
                    this.worker.postMessage({fileChunkList});
                    this.worker.onmessage = (e) => {
                        const {percentage, hash} = e.data;
                        if (this.uploadFiles[this.fileIndex]) {
                            this.uploadFiles[this.fileIndex].hashProgress = Number(percentage.toFixed(0));
                            this.$set(this.uploadFiles, this.fileIndex, this.uploadFiles[this.fileIndex]);
                        }
                        if (hash) {
                            resolve(hash);
                        }
                    };
                });
            },
            // 切片上传进度
            createProgresshandler(item, hasUploaded) {
                // console.log('createProgresshandler -> item', item);
                return (p) => {
                    // console.log("createProgresshandler p is " + JSON.stringify(p))
                    // console.log("p.loaded " + p.loaded)
                    // console.log("p.total " + p.total)
                    item.progress = parseInt(String((p.loaded / p.total) * 100));
                    // console.log("item.progress " + item.progress)
                    this.fileProgress(hasUploaded);
                };
            },
            // 文件总进度
            fileProgress(hasUploadled) {
                const currentFile = this.uploadFiles[this.fileIndex];
                if (currentFile) {
                    // console.log("currentFile is " + this.fileIndex)
                    // console.log("currentFile.chunkList is " + JSON.stringify(currentFile.chunkList))
                    const uploadProgressList = currentFile.chunkList.map((item) => item.size * item.progress)
                    // console.log("uploadProgressList is " + JSON.stringify(uploadProgressList))
                    let uploadSize = 0
                    uploadProgressList.forEach(item => {
                        if (item != null && item > 0) {
                            // console.log("item is " + item)
                            uploadSize += item
                        }
                    })
                    // console.log("uploadSize " + uploadSize)
                    // console.log("hasUploaded " + hasUploadled)
                    uploadSize += hasUploadled * chunkSize * 100
                    // console.log("111111111111 uploadSize " + uploadSize)
                    // console.log("fileSize " + currentFile.size)
                    let currentFileProgress = parseInt((uploadSize / currentFile.size).toFixed(2));
                    // console.log("uploadProgress " + uploadProgress)
                    // console.log("currentFileProgress " + currentFileProgress)
                    // 真假进度条处理--处理进度条后移
                    if (!currentFile.fakeUploadProgress) {
                        // console.log("111111111111111111111111111111111111111111")
                        currentFile.uploadProgress = currentFileProgress;
                        this.$set(this.uploadFiles, this.fileIndex, currentFile);
                    } else if (currentFileProgress > currentFile.fakeUploadProgress) {
                        // console.log("222222222222222222222222222222222")
                        currentFile.uploadProgress = currentFileProgress;
                        this.$set(this.uploadFiles, this.fileIndex, currentFile);
                    }
                }
            },

            setAxios() {
                if (!this.headers) return;
                for (const i in this.headers) {
                    instance.defaults.headers.common[i] = this.headers[i];
                }

                // 是否携带cookie
                if (this.withCredentials) {
                    instance.defaults.withCredentials = true;
                }

                // 设置baseUrl
                if (this.baseUrl) {
                    instance.defaults.baseURL = this.baseUrl;
                }

                // 设置切片大小
                chunkSize = this.chunkSize;
            },
            // 清空文件
            clearFiles() {
                console.log('清空文件');
                this.fileIndex = 0;
                this.handlePause();
                this.worker && this.worker.terminate(); // 中断worker
                this.status = Status.wait;
                Object.assign(this.$data, this.$options.data()); // 重置data所有数据
            },
            clearOneFile(uuid) {
                let newUploadFiles = []
                this.uploadFiles.forEach(file=>{
                    if (file.chunkList && file.chunkList[0].fileHash != uuid) {
                        newUploadFiles.push(file)
                    }
                })
                this.uploadFiles = JSON.parse(JSON.stringify(newUploadFiles))
                console.log("clearOneFile " + uuid)
                console.log("uploadFiles " + JSON.stringify(newUploadFiles))
            },
            // 判断是否都已完成上传
            isAllStatus(uploadOneFile) {
                // console.log("uploadOneFile is " + JSON.stringify(uploadOneFile))
                // this.uploadFiles.forEach(item=>{
                //     console.log("item is " + JSON.stringify(item))
                // })
                const isAllSuccess = this.uploadFiles.every((item) => ['success', 'secondPass', 'error'].includes(item.status));
                console.log('mergeRequest -> isAllSuccess', isAllSuccess);
                if (isAllSuccess) {
                    this.status = Status.done;
                    // this.$message.success("上传完成")
                    this.$emit('upload_done', uploadOneFile)
                } else {
                    this.$emit('upload_one', uploadOneFile)
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    .simple-upload-container {
        width: 100%;
        /*border: 1px solid #d2d2d2;*/
        border-radius: 4px;
        background-color: #fff;
        /*padding-bottom: 15px;*/
        /*padding: 10px;*/

        .progress-box {
            font-size: 14px;
            color: #333;
            width: 100%;
        }

        .total-progress {
            margin-bottom: 15px;

            .btns {
                position: relative;
                .select-file-input {
                    position: absolute;
                    display: inline-block;
                    left: 0;
                    top: 0;
                    border: none;
                    opacity: 1;
                    width: 96px;
                    height: 28px;
                }
            }
        }
        .file-list {
            .list-item {
                padding: 8px 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                justify-items: center;
                line-height: 22px;
                /*background-color: red;*/
                position: relative;

                .item-name {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-right: 6px;
                    width: 300px;
                    font-size: 14px;
                    /*background-color: blue;*/
                }
                .item-size {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    /*margin-right: 6px;*/
                    width: 160px;
                    text-align: right;
                    font-size: 14px;
                    /*background-color: green;*/
                }

                .item-progress {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    align-items: center;
                    justify-content: flex-start;
                    span {
                        width: 30%;
                        font-size: 12px;
                        color: #333;
                    }
                    /*flex: 0 0 60%;*/
                }
                .item-wait{
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    align-items: flex-start;
                    justify-content: flex-start;
                    span {
                        /*background-color: red;*/
                        width: 40%;
                        font-size: 12px;
                        color: #333;
                    }
                }
            }
        }

        .upload-tip {
            font-size: 12px;
            color: #606266;
            margin-top: 7px;
        }

        .el-progress {
            width: 80%;
            display: inline-block;
        }

        .el-collapse-item__header {
            height: auto;
        }

    }
</style>
